import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { GavelIcon } from '@jjj/move';
import { Image } from './globalSearch.style';

export const getIconByType = (type, image) => {
  if (image) {
    return <Image src={image} alt="" />;
  }

  switch (type) {
    case 'worker':
    case 'talent':
    case 'denied_worker':
    case 'terminated_worker':
      return <PersonOutlineRoundedIcon />;
    case 'applicant':
      return <PersonAddAltOutlinedIcon />;
    case 'manager':
      return <ManageAccountsOutlinedIcon />;
    case 'company':
    case 'subunit':
    case 'unit':
    case 'division':
      return <ApartmentOutlinedIcon />;
    case 'job':
      return <WorkOutlineOutlinedIcon />;
    case 'invoice':
    case 'consolidated_invoice':
      return <ReceiptLongOutlinedIcon />;
    case 'legal_entity':
      return <GavelIcon />;
    default:
      return <PersonOutlineRoundedIcon />;
  }
};

export const getRedirectLink = (type, id, company, workerIdentityId) => {
  switch (type) {
    case 'worker':
    case 'talent':
      return `/talent/${id}`;
    case 'denied_worker':
      return `/denied/${id}`;
    case 'terminated_worker':
      return `/terminated/${id}`;
    case 'applicant':
      return `/applicants/${id}`;
    case 'subunit':
      return `/subUnits/${id}`;
    case 'unit':
      return `/units/${id}`;
    case 'manager':
      if (company?.level === 'subunit') {
        return `/subUnits/${company?.id}/managers/${id}`;
      }

      return `/units/${company?.id}/managers/${id}`;
    case 'company':
      return `/companies/${id}`;
    case 'job':
      return `/jobs/${id}`;
    case 'invoice':
      if (company?.level === 'subunit') {
        return `/subUnits/${company.id}/invoices/${id}`;
      }

      return `/units/${company?.id}/invoices/${id}`;
    case 'consolidated_invoice':
      return `/agencies/invoices/consolidated/${id}`;
    case 'division':
      return `/divisions/${id}`;
    case 'agency_worker':
      return `/agencyWorkers/${workerIdentityId}`;
    case 'legal_entity':
      return '/legalEntities';
    default:
      return '/';
  }
};
